var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2157 23.4813L10.0533 29.7077C8.80463 30.1357 7.44131 29.4892 7.02368 28.271L3.05625 16.6981C2.80947 15.9782 2.92222 15.197 3.39469 14.54L11.3515 3.89149L24.1679 7.41852C24.9251 7.5921 25.5124 8.19521 25.7592 8.91506L29.7267 20.488C30.1443 21.7062 29.4643 23.0532 28.2157 23.4813Z",
    fill: "#78909C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8656 6.39097L17.2171 2.49947L23.1018 19.6651L11.7503 23.5566L5.8656 6.39097Z",
    fill: "#AED581"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.10815 6.03181L11.3725 24.3049L23.8592 20.0243L17.5948 1.75116L5.10815 6.03181ZM22.3443 19.306L12.128 22.8083L6.62296 6.75012L16.8393 3.24777L22.3443 19.306Z",
    fill: "#558B2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5967 3.60691C17.9195 4.54825 17.996 5.32647 17.0311 5.65725C16.0662 5.98803 15.0816 5.52113 14.7589 4.57978C14.4362 3.63844 15.1171 3.21937 16.0819 2.8886C17.0468 2.55782 17.274 2.66556 17.5967 3.60691ZM7.00075 6.0018C7.96563 5.67102 8.76042 5.58419 9.08313 6.52553C9.40584 7.46688 8.91477 8.43967 7.9499 8.77045C6.98502 9.10123 6.56797 8.43975 6.24526 7.49841C5.92255 6.55706 6.03587 6.33257 7.00075 6.0018Z",
    fill: "#558B2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2498 9.42876C13.8767 9.21384 14.215 8.54379 14.0053 7.93215C13.7956 7.32052 13.1174 6.99892 12.4905 7.21384C11.8636 7.42876 11.5253 8.09882 11.735 8.71045C11.9447 9.32209 12.6229 9.64368 13.2498 9.42876Z",
    fill: "#558B2F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.287 18.2885C18.1678 17.6437 19.1825 15.6336 18.5535 13.7987C17.9245 11.9637 15.8899 10.999 14.0091 11.6437C12.1283 12.2885 11.1136 14.2986 11.7426 16.1336C12.3717 17.9685 14.4063 18.9333 16.287 18.2885Z",
    fill: "#558B2F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2156 23.4813L10.0533 29.7077C8.80459 30.1357 7.44126 29.4892 7.02364 28.271L3.22705 17.1964L17.0463 20.5034L25.93 9.41342L29.7266 20.488C30.1442 21.7062 29.4643 23.0532 28.2156 23.4813Z",
    fill: "#CFD8DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.5e003b14eadd993001734607107918ba.svg";
export { ForwardRef as ReactComponent };